import React, { useState } from 'react';
import { NeutralColors } from '@fluentui/react';
import { DismissRegular, ArrowUndoRegular } from '@fluentui/react-icons';
import MilestoneCardActionButton from './MilestoneCardActionButton';
import { IMilestoneCardHeaderProps } from './MilestoneCardHeader';
import { TeachingPopoverProps } from '../../common/ActionButtons';

const MilestoneCardActions = (props: IMilestoneCardHeaderProps): JSX.Element => {
  const {
    onHeaderClick,
    iconClick,
    isDisabled,
    isCurrent,
    icon,
    title,
    actionText,
    showProcessExtensionWarning,
  } = props;
  const [showTeachingPopover, setShowTeachingPopover] = useState(false);
  const getHeaderTextColor = (): string => {
    return !isCurrent ? 'inherit' : NeutralColors.white;
  };

  const labelStyles = {
    fontWeight: 400,
    color: getHeaderTextColor(),
    marginRight: 20,
  };
  const getButtonText = (): string => {
    if (icon === ArrowUndoRegular) return 'Rescind';
    if (icon === DismissRegular) return 'Cancel';
    return 'Signoff';
  };

  const teachingPopoverProps: TeachingPopoverProps = {
    header: 'Extension Currently In Progress',
    content:
      'This process has an extension in progress and cannot be signed off until this request is completed.',
    showTeachingPopover,
    setShowTeachingPopover,
  };

  return (
    <>
      <div className="ms-hiddenMdDown" style={labelStyles}>
        {actionText}
      </div>
      <MilestoneCardActionButton
        isCurrent={isCurrent}
        iconProps={icon}
        title={getButtonText()}
        ariaLabel={`${getButtonText()} ${title}`}
        disabled={isDisabled}
        teachingPopoverProps={teachingPopoverProps}
        onClick={(ev: React.MouseEvent<HTMLElement, MouseEvent>): void => {
          ev.stopPropagation();
          onHeaderClick(false);
          if (showProcessExtensionWarning) {
            setShowTeachingPopover(true);
            return;
          }
          iconClick();
        }}
      />
    </>
  );
};
export default MilestoneCardActions;
